import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SupplierInfoModalComponent } from '../supplier-info-modal/supplier-info-modal.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-quota-header',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatDialogModule, MatTooltipModule, TranslateModule],
  templateUrl: './quota-header.component.html',
  styleUrl: './quota-header.component.css',
})
export class QuotaHeaderComponent {
  @Input() quotaCount: number = 0;
  @Input() activeTab: 'all' | 'my' | 'companies' = 'all';

  private dialog = inject(MatDialog);
  private translate = inject(TranslateService);
  private router = inject(Router);

  get title(): string {
    if (this.activeTab === 'my') return this.translate.instant('quota.myApplications');
    if (this.activeTab === 'companies') return 'Мои компании';
    return this.translate.instant('quota.title');
  }

  get subtitle(): string {
    if (this.activeTab === 'my') return this.translate.instant('quota.mySubtitle');
    if (this.activeTab === 'companies') return 'Компании, зарегистрированные на вашем аккаунте';
    return this.translate.instant('quota.subtitle');
  }

  navigateToTab(tab: 'all' | 'my' | 'companies'): void {
    if (tab === 'my') {
      this.router.navigate(['/my-applications']);
    } else if (tab === 'companies') {
      this.router.navigate(['/my-companies']);
    } else {
      this.router.navigate(['/']);
    }
  }

  openInfoModal(): void {
    this.dialog.open(SupplierInfoModalComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh'
    });
  }
}
